import type { InventoryMovement } from '../../shared/api/types';

export const MOVEMENT_KIND: Record<InventoryMovement['kind'], string> = {
  entry: 'Entrada',
  exit: 'Salida',
  consumption: 'Consumo',
  return: 'Devolución',
  adjustment: 'Ajuste',
  transfer_in: 'Traslado (llega)',
  transfer_out: 'Traslado (sale)',
};

export const formatQuantity = (n: number) => new Intl.NumberFormat('es-MX', { maximumFractionDigits: 3 }).format(n);

/** "1,5" o "1.5" → 1.5; null si no es un número. */
export function parseQuantity(text: string): number | null {
  const clean = text.trim().replace(',', '.');
  if (!/^-?\d+(\.\d{1,3})?$/.test(clean)) return null;
  const n = Number(clean);
  return n === 0 ? null : n;
}
